import get from 'transmute/get';
export const checkIsUserOption = option => Boolean(get('email', option));